import { render, staticRenderFns } from "./ItemCidConfirmDialog.vue?vue&type=template&id=bc6c24e8&scoped=true"
import script from "./ItemCidConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ItemCidConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ItemCidConfirmDialog.vue?vue&type=style&index=0&id=bc6c24e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c24e8",
  null
  
)

export default component.exports